import { Dimmer, Text } from '@wework/dieter-ui'
import Row from '../../components/Common/Row'
import React, { useState } from 'react'
import DiscountIcon from '../../assets/images/DiscountIcon.svg'
import './styles.css'
import withDiscounts from '../../hoc/withDiscounts'
import { Loader, Segment } from 'semantic-ui-react'
import IMTheme from '../../style/IMTheme'

function Discounts({
  space,
  discounts,
  loadingDiscounts,
  discountsError,
  floorMap,
}) {
  const [collapsed, setCollapsed] = useState(true)

  if (discountsError) {
    return null
  }
  if (!loadingDiscounts && discounts.length === 0) {
    return null
  }
  return (
    <div>
      <Row justify="space-between" style={{ marginBottom: IMTheme.spacing[2] }}>
        <Row justify="flex-start">
          <DiscountIcon />
          <Text
            style={{
              fontWeight: IMTheme.fontWeights.bold,
              fontSize: IMTheme.fontSizes[2],
              marginLeft: IMTheme.spacing[4],
            }}
          >
            CPB Discounts
          </Text>
        </Row>
        {loadingDiscounts ? (
          <Loader active inline size="small" />
        ) : (
          <Text
            primary
            style={{ fontSize: IMTheme.fontSizes[2], cursor: 'pointer' }}
            onClick={() => setCollapsed(!collapsed)}
          >
            {collapsed ? 'Show' : 'Hide'}
          </Text>
        )}
      </Row>

      {!collapsed && !loadingDiscounts && (
        <Row justify="flex-start" style={{ marginBottom: IMTheme.spacing[4] }}>
          <div
            style={{
              flexDirection: 'column',
              display: 'flex',
              marginLeft: IMTheme.spacing[6],
            }}
          >
            {discounts.map((discount, index) => {
              return (
                <Text
                  key={index}
                  style={{ fontSize: IMTheme.fontSizes[2] }}
                >{`${discount.length} months`}</Text>
              )
            })}
          </div>
          <div
            style={{
              flexDirection: 'column',
              display: 'flex',
            }}
          >
            {discounts.map((discount, index) => {
              const prcnt = Math.round(discount.max_discount * 100)
              const dm = `up to ${prcnt}%`
              return (
                <Row key={index} justify="flex-start">
                  <Text
                    style={{
                      fontSize: IMTheme.fontSizes[2],
                      marginLeft: IMTheme.spacing[4],
                      marginRight: IMTheme.spacing[4],
                    }}
                  >
                    {'-'}
                  </Text>
                  <Text style={{ fontSize: IMTheme.fontSizes[2] }}>{dm}</Text>
                </Row>
              )
            })}
          </div>
        </Row>
      )}
    </div>
  )
}

export default withDiscounts(Discounts)
